import React from 'react';
import { type TextFragment } from '@/utils/text-kit';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';

type Props = {
    layer: ILayerProps;
    listMarkerFragments: TextFragment[];
};

export const ImageTypedListMarkerRenderer: React.FC<Props> = ({ layer, listMarkerFragments }) => {
    const layerData = layer.data as ITextLayerProps;
    const { fontSize } = layerData;

    const config = layerData.listStyleMaterial!;
    const { url, baseContentTextSize: baseFontSize, iconWidth: originWidth, iconHeight: originHeight } = config;
    const ratio = fontSize / baseFontSize;
    const width = originWidth * ratio * config.scale;
    const height = originHeight * ratio * config.scale;

    const id = `list-marker-image-typed-${layer.id}`;

    return (
        <g data-role="list-marker">
            <defs>
                <image id={id} href={url} width={width} height={height} preserveAspectRatio="xMidYMid slice" />
            </defs>

            {listMarkerFragments.map((item) => {
                const x = item.left;
                const y = item.top;

                return (
                    <React.Fragment key={`${id}-${item.listOrder}`}>
                        <use xlinkHref={`#${id}`} x={x} y={y} />
                    </React.Fragment>
                );
            })}
        </g>
    );
};
